// WP-1.15 (RE-4, NF-7, S-09 export): a currency-of-the-realm-neutral "tabular data" shape and
// a pure CSV renderer. No engine state, the same standalone-module split as csvImport.ts. The
// caller (web) builds a `TabularData` from whatever filtered table it's showing; `toCsv`/`toXlsx`
// (xlsx.ts) turn it into the two RE-4-LOCKED formats. Every export carries a valuation-basis
// footnote (RE-4: "actual vs indicative") supplied by the caller as `footnotes`.

export interface TabularColumn {
  key: string;
  label: string;
}

/** A cell is text or a number; numbers export as real numeric cells (spreadsheet math works). */
export type TabularCell = string | number;

export interface TabularData {
  columns: TabularColumn[];
  rows: Record<string, TabularCell | undefined>[];
  footnotes?: string[];
}

// RFC 4180: quote a field iff it contains a comma, a double-quote, or a line break; escape an
// embedded quote by doubling it.
function csvCell(value: TabularCell | undefined): string {
  const s = value === undefined ? '' : String(value);
  if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function toCsv(data: TabularData): string {
  const lines: string[] = [];
  lines.push(data.columns.map((c) => csvCell(c.label)).join(','));
  for (const row of data.rows) {
    lines.push(data.columns.map((c) => csvCell(row[c.key])).join(','));
  }
  if (data.footnotes !== undefined && data.footnotes.length > 0) {
    lines.push(''); // a blank separator line before the footnotes
    for (const footnote of data.footnotes) lines.push(csvCell(footnote));
  }
  return lines.join('\r\n');
}
